export default function useExtension() {
  const config = useRuntimeConfig()

  const isChromeBrowser = computed(() => {
    return !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
  })

  const getChromeExtensionVersion = async () => {
    if (isChromeBrowser.value) {
      const response = await sendMessage({ action: 'extension:version' })

      return response?.version
    }

    return false
  }

  const sendMessage = (
    message: { [key: string]: any },
    options?: { [key: string]: any },
  ): Promise<{ [key: string]: any }> => {
    return new Promise((resolve, reject) => {
      if (isChromeBrowser.value) {
        window.chrome.runtime.sendMessage(config.public.extensions.chrome.id, message, options, (response: any) => {
          if (response?.error) {
            reject(response.error)
          }
          else {
            resolve(response)
          }
        })
      }
      else {
        resolve({ error: 'Extension not found' })
      }
    })
  }

  return {
    getChromeExtensionVersion,
    isChromeBrowser,
    sendMessage,
  }
}
